export default "__VITE_ASSET__hw9_XgA7__"